// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var List = function List(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M1.589 2.539h1.98v1.98h-1.98zM5.425 2.539h8.986v1.98H5.425zM1.589 6.979h1.98v1.98h-1.98zM5.425 6.979h8.986v1.98H5.425zM1.589 11.481h1.98v1.98h-1.98zM5.425 11.481h4.992v1.98H5.425z"
    }))
  );
};

export default List;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/List.js
// module id = 1026
// module chunks = 0